<template>
  <div class="container">
    <div class="coupon-header">
      優惠碼兌換
    </div>
    <!-- 筛选 -->
    <div class="filter">
      <div>
        <el-row>
          <el-col>
            <el-input
              v-model="couponNo"
              class="w180 r15"
              placeholder="請輸入優惠碼編號"
              suffix-icon="el-icon-search"
            />
            <el-select
              v-model="couponCoinType"
              class="w150 seled r15"
              placeholder="貨幣類型"
            >
              <el-option
                v-for="(item, index) in coinTypeList"
                :key="index+2"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
            <span class="pm">數量：</span>
            <el-input
              v-model="startCoin"
              class="w90"
              placeholder=" "
            />
            <span class="pm">-</span>
            <el-input
              v-model="endCoin"
              class="w90 r15"
              placeholder=" "
            />
            <span class="time">兌換時間：</span>
            <el-date-picker
              v-model="startUseTime"
              class="w150 mr4"
              format="yyyy/MM/dd"
              value-format="timestamp"
              :picker-options="publicTimeOption2"
              type="date"
              placeholder="選擇日期"
            />-
            <el-date-picker
              v-model="endUseTime"
              class="w150 r15"
              format="yyyy/MM/dd"
              value-format="timestamp"
              :picker-options="publicTimeOption"
              type="date"
              placeholder="選擇日期"
            />
            <span class="btn-filter">
              <el-button
                type="danger"
                @click="clickSearch"
              >搜尋</el-button>
              <el-button
                type="info"
                @click="resetSearch"
              >重置</el-button>
            </span>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="line" />
    <!-- 功能按钮 -->
    <div :class="{ button: true, fixed: !isFixed && !sideBar, 'fixed-1': isFixed, 'fixed-2': !sideBar }">
      <span>
        <span
          class="span"
          @click="addcoupon"
        >
          <svg
            class="icon"
            aria-hidden="true"
          >
            <use xlink:href="#iconduihuanyouhuiquan2" />
          </svg>
          <span class="btn-text">優惠碼兌換</span>
        </span>
      </span>
    </div>
    <!-- 表格 -->
    <div
      v-if="isFixed"
      class="button2"
    />
    <div class="table">
      <div class="text-list">
        <el-table
          v-loading="firstLoading"
          empty-text="暫無數據"
          :header-cell-style="{ background: 'rgba(80,181,255,0.15)', color: '#444' }"
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            v-for="column in tableColumns"
            :key="column.label"
            :prop="column.prop"
            :label="column.label"
            :width="calcWidth('25%')"
            :align="column.align"
          >
            <!-- 金币钻石无数据显示 - -->
            <template slot-scope="scope">
              {{ column.prop == 'useTime' ? scope.row[column.prop].replace('T', ' ').slice(0, 16) : (column.prop == 'propertyCoin' || column.prop == 'diamond') ? (scope.row[column.prop] ? scope.row[column.prop] : '-') : scope.row[column.prop] }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          class="page"
          background
          :page-size="pageCount"
          :page-sizes="[10, 20, 50, 100]"
          layout="total,sizes,prev, pager, next,jumper"
          :current-page.sync="pageIndex"
          :total="count"
          @size-change="sizeChange"
          @current-change="currentChange"
        />
      </div>
    </div>
    <el-dialog
      top="25vh"
      class="couponclass"
      title="優惠碼兌換"
      width="520px"
      :close-on-click-modal="false"
      :visible.sync="showCoupon"
      @close="cancelExchange"
    >
      <div class="coupon-tishi">
        <span>優惠碼密碼：</span>
        <span>
          <el-input
            ref="input1"
            v-model="fsecret"
            class="w60"
            @input="inputFous(1)"
          />
        </span>
        <span class="pad5" />
        <span>
          <el-input
            ref="input2"
            v-model="ssecret"
            class="w60"
            :maxlength="4"
            @input="inputFous(2)"
          />
        </span>
        <span class="pad5" />
        <span>
          <!-- @blur="patternInput('tsecret')" -->
          <el-input
            ref="input3"
            v-model="tsecret"
            class="w60"
            :maxlength="4"
          />
        </span>
        <div
          v-if="showValidMessage"
          class="couponValid"
        >
          {{ this.validMessage }}
        </div>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="cancelExchange">
          取 消
        </el-button>
        <el-button
          type="primary"
          :disabled="secretKey.length<12"
          @click="couponExchange"
        >
          確 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
 data() {
  return {
    count: 0,
    firstLoading: true,
    couponNo:'',
    couponCoinType:'',
    startCoin:'',
    endCoin:'',
    startUseTime:'',
    endUseTime:'',
    pageIndex:1,
    pageCount:10,
    fsecret:'',
    ssecret:'',
    tsecret:'',
    coinTypeList:[
        {name:'金幣',value:1},
        {name:'鑽石',value:2},
    ],


    tableData:[],
    tableColumns: [
        { label: '優惠碼編號', prop: 'couponNO', width: 220, align: 'left' },
        { label: '優惠碼密碼', prop: 'secretKey', width: 500, align: 'left' },
        { label: '金幣數量', prop: 'propertyCoin', width: 100, align: 'left' },
        { label: '鑽石數量', prop: 'diamond', width: 100, align: 'left' },
        { label: '時間', prop: 'useTime', width: 220, align: 'left' },
    ],

    isFixed: false,
    publicTimeOption: {
        disabledDate: this.publicTimeOption1
    },
    publicTimeOption2: {
        disabledDate: this.publicTimeOption3
    },
    minCreateTime:'',
    maxCreateTime:'',
    scrollValue:0,
    showCoupon:false,
    validMessage:'',
    showValidMessage:false,
    secretKey:''
  }
 },
 created(){
    this.getCompanyCofig()
    this.pageCount = this.pub.getPageSize(this.$store.state.userInfo.accountID, 'couponPageCount') || 10;
    this.clickSearch()
 },
 mounted() {
    document.querySelector('.el-main').addEventListener('scroll', this.handleScroll);
},
 methods:{
    getCompanyCofig(){
        let showPage = false
        this.axios.get(this.pub.getApi().GetCompanyCofig).then(res => {
            if (res.data.code === 0 && res.data.result) {
                showPage = res.data.result.isUseCoupon
                if(!showPage){this.$router.push('/homepage')}
            }else{
                this.$router.push('/homepage')
            }
        });
    },
    inputFous(inputIndex){
        if(inputIndex === 1){
            if(this.fsecret.replace(/[-\s]/g, '').length == 12){
                let val = this.fsecret.replace(/[-\s]/g, '')
                this.fsecret = val.substring(0,4)
                this.ssecret = val.substring(4,8)
                this.tsecret = val.substring(8,12)
            }else if (this.fsecret.length === 4) {
                this.$refs.input2.focus();
            }else if((this.fsecret.length >4 && this.fsecret.replace(/\s/g, '').length < 12) ||this.fsecret.replace(/\s/g, '').length > 12){
                let val = this.fsecret.replace(/\s/g, '')
                this.fsecret = val.substring(0,4)
                this.$refs.input2.focus();
            }
        } else if (inputIndex === 2 && this.ssecret.length === 4) {
                this.$refs.input3.focus();
            }
        
    },
    patternInput(typeData){
        this[typeData] = this[typeData].replace(/[^\a-\z\A-\Z0-9]/g, '');
    },
    success(info) {
      this.$message({
        showClose: true,
        message: info,
        type: 'success',
        offset: document.body.clientHeight / 2
      });
    },
    couponExchange(){
        this.axios.post(this.pub.getApi().UseCoupon, {secretKey:this.secretKey}).then(res => {
            if (res.data.code == 0) {
                this.showCoupon = false
                this.success('兌換成功');
                this.clickSearch()
            }else{
                this.showValidMessage = true
                this.validMessage = res.data.message
            }
        });
    },
    cancelExchange(){
        this.secretKey = ''
        this.fsecret = ''
        this.ssecret = ''
        this.tsecret = ''
        this.showCoupon = false
    },
    async clickSearch(){
        this.firstLoading =  true
        const data = this.getSearchValue();
        await this.axios.post(this.pub.getApi().SearchCoupon, data).then(res => {
            if (res.data.code == 0) {
                this.count = res.data.result.count
                this.tableData = res.data.result.data
                this.firstLoading =  false
            }
        });
    },
    currentChange(pageIndex) {
        this.pageIndex = pageIndex;
        this.clickSearch()
    },
    getSearchValue(){
        const data = {};
        data.pageIndex = this.pageIndex;
        data.pageCount = this.pageCount;
        if(this.couponNo){data.couponNo = this.couponNo}
        if(this.couponCoinType){data.couponCoinType = this.couponCoinType}
        if(this.startCoin){data.startCoin = this.startCoin}
        if(this.endCoin){data.endCoin = this.endCoin}
        if (this.startUseTime) {data.startUseTime = parseInt(this.startUseTime / 1000);}
        if (this.endUseTime) {data.endUseTime = parseInt(this.endUseTime / 1000 + 24 * 60 * 60);}
        return data
    },
    resetSearch(){
        this.couponNo=''
        this.couponCoinType=''
        this.startCoin=''
        this.endCoin=''
        this.startUseTime=''
        this.endUseTime=''
        this.pageIndex=1
        this.pageCount=10
        this.clickSearch()
    },
    addcoupon(){
        this.validMessage = ''
        this.showCoupon = true
    },
    sizeChange(data) {
        this.pub.userPageSize(this.$store.state.userInfo.accountID, 'couponPageCount', data);
        this.pageCount = data;
        this.clickSearch()
    },
    calcWidth(width) {
            return `calc(${width} - 20px)`;
    },
    publicTimeOption1(time) {
        if (this.minCreateTime) {
            return time.getTime() < this.minCreateTime;
        } 
            return false;
        
    },
    publicTimeOption3(time) {
        if (this.maxCreateTime) {
            return time.getTime() > this.maxCreateTime;
        } 
            return false;
        
    },
    handleScroll() {
        this.scrollValue = document.querySelector('.el-main').scrollTop;
    },
 },
 computed: {
    ...mapGetters(['page', 'sideBar']),
    concatenatedKey(){
        return this.fsecret+"-"+this.ssecret +"-"+this.tsecret
    }
 },
 watch: {
    concatenatedKey(newVal) {
      this.secretKey = newVal;
      this.showValidMessage = this.secretKey.length>2?true:false
    },
     scrollValue(val) {
         if (val >= 150) {
            this.isFixed = true;
         } else {
            this.isFixed = false;
         }
     }
 }
}
</script>

<style scoped lang="less">
.container{
    text-align: left;
    .w180 {
        width: 180px;
        margin-right: 15px;
        margin-bottom: 10px;
    }
    .w150 {
        width: 150px;
    }
    .w90{
        width:90px;
    }
    .w60{
        width:71px;
      
        /deep/.el-input__inner {
            border-radius: 15px !important;
            background-color: #FAFAFB;
        }
    }
    .pad5{
        height: 2px;
        background-color: #e2e2ea;
        margin: 3px 5px;
        width: 9px;
        display:inline-block;
    }
    .couponclass{
        .coupon-tishi{
            margin-left:12px;
            .couponValid{
                margin-left:85px;
                font-size:14px ;
                color:#E50113 ;
            }
        }
    }
    /deep/.el-dialog {
    border-radius: 10px;
}
/deep/ .el-dialog__header {
    padding: 0;
    padding-left: 32px;
    height: 45px;
    line-height: 45px;
    box-sizing: border-box;
    border-radius: 10px 10px 0 0;
    background: #fafafb;
    border-bottom: 1px solid #eee;
    .el-dialog__title {
        font-size: 16px;
        color: #92929d;
    }
    .el-dialog__headerbtn {
        top: 12px;
    }
}
    .r15{
        margin-right:15px;
    }
    .footer {
    input {
        border-radius: 4px;
    }
    span {
        font-size: 14px;
        color: #44444f;
        margin-left: 16px;
    }
    margin-top: 16px;
    padding-top: 20px;
    // box-sizing: border-box;
    height: 72px;
    .page {
        float: right;
    }
    .input-number {
        input {
            border-radius: 0px;
        }
        text-align: left;
        float: right;
        width: 70px;
    }
    /**覆盖计数器样式 */
    .el-input-number.is-controls-right .el-input__inner {
        padding-left: 8px;
        padding-right: 42px;
        overflow: hidden;
    }
}
    .table{
        width: 100%;
        height: 100%;
        background-color: #fff;
        border-radius: 20px;
        padding: 20px;
        box-sizing: border-box;
        .el-table__header tr,
        .el-table__header th {
            padding: 0 !important;
            height: 38px;
        }
        /**修改表格背景 */
        .el-table tbody tr:hover > td {
            background-color: rgba(80, 181, 255, 0.1) !important;
        }
        /** */
        /deep/ .el-table thead tr {
            th:first-child {
                border-radius: 10px 0 0 10px;
            }
            th:nth-last-child(2) {
                border-radius: 0 10px 10px 0;
            }
        }
        .el-table th {
            border: none;
        }
        /**分割线 */
        .el-table td {
            border-bottom: 1px solid #e2e2ea;
        }
        table {
            .btn-table {
                color: #222;
            }
            .btndisable {
                pointer-events: none;
            }
            color: #222;
            font-size: 14px;
            tr th .cell {
                line-height: 38px;
                font-weight: normal;
                font-size: 13px;
                color: #444444;
            }
        }
    }
    .coupon-header{
        font-size: 24px;
        color: #171725;
        padding: 0 0 20px 0;
    }
    .filter{
        padding-bottom: 16px;
        .seled {
            ::placeholder {
                color: #000000;
            }
        }
        /deep/.el-input__inner {
            border-radius: 10px !important;
        }
        .pm {
            margin: 0 6px;
        }
        .time {
            font-size: 14px;
            color: #666;
        }
        .mr4 {
            margin-right: 5px;
        }
        .btn-filter {
            padding-left: 10px;
            display: inline-block;
            padding-bottom: 16px;
            .el-button--danger {
                background: #e50113;
            }
        }

    }
    .line {
        width: 100%;
        height: 1px;
        background-color: #e2e2ea;
    }
    .button {
        top: 50px;
        z-index: 999;
        padding: 10px 0px 12px 0px;
        box-sizing: border-box;
        background-color: #f3f3f5;
        overflow: hidden;
        margin-bottom: 6px;
        .span {
            margin-top: 14px;
            position: relative;
            top: -2px;
            cursor: pointer;
            display: inline-block;
            padding: 0 14px 0 0;
            .icon {
                font-size: 20px;
            }
            .btn-text {
                position: relative;
                top: 0px;
                font-size: 15px;
                padding-left: 5px;
                color: #0062ff;
            }
            .ban {
                color: #666;
            }
        }
    }
    button {
        border-radius: 10px;
        width: 88px;
        height: 38px;
    }
    .fixed-1 {
        padding: 12px 24px 12px 30px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
        position: fixed;
        left: 170px;
        width: calc(100% - 140px);
        transform: translateX();
        transition-duration: 1s;
    }
    /**宽度改变 */
    .fixed-2 {
        width: calc(100% - 60px);
        left: 60px;
    }
    /**解决 */
    .fixed {
        width: 100%;
    }
    
}

</style>
